import ReactDOM from "react-dom";
import App from "./App";
import { InstantSearch } from "react-instantsearch-hooks-web";
import { searchClient } from "./algoliaClient";
import "./index.css";

ReactDOM.render(
	<InstantSearch searchClient={searchClient} indexName="products">
		<App />
	</InstantSearch>,
	document.getElementById("react-product-search"),
);
